const DARK_LABEL_SLUGS = ["ai-agent-kundenservice-automatisieren", "top-10-ai-agent-plattformen-2026"];

const AIGeneratedLabel = ({ slug }: { slug?: string }) => {
  const dark = !!slug && DARK_LABEL_SLUGS.includes(slug);
  return (
    <span
      className={`pointer-events-none absolute top-2 right-3 z-10 text-[11px] md:text-xs font-medium ${dark ? "text-primary" : "text-primary-foreground"}`}
      style={dark ? undefined : { textShadow: "0 1px 3px rgba(0,0,0,0.45)" }}
    >
      AI-generated Image
    </span>
  );
};

export default AIGeneratedLabel;
